import { render, staticRenderFns } from "./CanceledCallRequestsTable.vue?vue&type=template&id=01ea72ca"
import script from "./CanceledCallRequestsTable.vue?vue&type=script&lang=js"
export * from "./CanceledCallRequestsTable.vue?vue&type=script&lang=js"
import style0 from "./CanceledCallRequestsTable.vue?vue&type=style&index=0&id=01ea72ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports